import { Box, Divider } from '@mui/material';
import {
    DeleteButton,
    EditButton,
    ShowButton,
    useRecordContext,
    Button,
} from 'react-admin';
import { useCreatePath } from 'ra-core';
import { Link } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useLocation } from 'react-router';

import { Lead } from '@/types';

export const LeadAside = ({ link = 'edit' }: { link?: 'edit' | 'show' }) => {
    const location = useLocation();
    const record = useRecordContext<Lead>();
    if (!record) return null;

    const createPath = useCreatePath();
    const stopPropagation = (e: { stopPropagation: () => void }) => e.stopPropagation();

    return (
        <Box ml={4} width={250} minWidth={250}>
            {link === 'edit' ? (
                <>
                    <Box my={2}>
                        <Button
                            component={Link}
                            to={createPath({ resource: 'leads', type: 'list' })}
                            label="Back"
                            onClick={stopPropagation}
                        >
                            <ArrowBackIcon />
                        </Button>
                    </Box>
                    <Divider />
                </>
            ) : null}
            <Box my={2}>
                {link === 'edit' ? (
                    <EditButton label="Edit lead" />
                ) : (
                    <ShowButton label="Show lead" />
                )}
                <br />
                <DeleteButton
                    mutationMode="pessimistic"
                    redirect={location.state?.from || undefined}
                />
            </Box>
        </Box>
    );
};
